module.exports = __webpack_public_path__ + "static/media/choir-icon-white.5bc465fa.svg";